import api from './api'

const resource = '/apps/visitorcheck'

export default {
    check(params) {
        return api.post(`${resource}`, params);
    }
}